import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";

let displayProgressBarTimeoutId: number;

export function setProgressBarVisibility(): void {
  const isPlaying = lessonPlayerStore.getIsPlaying();
  const displayProgressBarForNms = 5000;

  lessonPlayerStore.setIsProgressBarShowing(true);

  if (isPlaying) {
    clearTimeout(displayProgressBarTimeoutId);
    displayProgressBarTimeoutId = window.setTimeout(() => {
      const isPlaying = lessonPlayerStore.getIsPlaying();
      if (isPlaying) {
        lessonPlayerStore.setIsProgressBarShowing(false);
      }
    }, displayProgressBarForNms);
  }
}
